<script setup>
import { formatScientific } from '@/utils/formatters'
import { mapUnitOrOriginal } from '@/components/combined-predict/components/CombinedPredictTable/utils/unitConversions'
import ReplacedChemical from '@/components/shared-table/components/ReplacedChemical.vue'

const popoverFields = [
  //   { key: 'predicted', label: 'Predicted' },
  { key: 'experimental', label: 'Experimental Value' },
  { key: 'ad_result', label: 'AD Result' },
  { key: 'ad_distance', label: 'AD Distance' },
]

const formatValue = (value, unit) => formatScientific(value, { unit })

const getFirstAdEstimate = (prediction) => {
  if (!prediction?.adEstimates?.length) return null
  return prediction.adEstimates[0] ?? null
}

const getAdResultConclusion = (prediction) => {
  const firstAd = getFirstAdEstimate(prediction)
  return firstAd?.conclusion ?? '-'
}

const getAdResultClass = (prediction) => {
  const conclusion = getAdResultConclusion(prediction)
  if (conclusion === 'Inside') return 'text-success'
  if (conclusion === 'Outside') return 'text-warning'
  return ''
}

const getAdReasoning = (prediction) => {
  const firstAd = getFirstAdEstimate(prediction)
  return firstAd?.reasoning ?? '–'
}

const shouldShowUnitsModel = (predictionForModel) => {
  return predictionForModel?.unitsDisplay !== predictionForModel?.unitsModel
}
</script>

<template>
  <v-card
    v-if="params?.data?.chemical && params?.predictionForModel"
    max-width="30rem"
    min-width="20rem"
    max-height="36rem"
    class="overflow-auto"
  >
    <ReplacedChemical
      :original-chemical="params?.data?.chemical"
      :standardization-change="params?.standardizationChange"
    />

    <v-divider class="mx-4 my-0" />

    <v-card-text class="p-3">
      <b-table-lite
        :fields="popoverFields"
        :items="[params?.predictionForModel]"
        borderless
        small
        stacked
        class="mb-0"
      >
        <!-- <template #cell(predicted)="data">
          <div v-if="data.item.predictionValueUnitsDisplay">
            {{ formatValue(data.item.predictionValueUnitsDisplay, data.item.unitsDisplay) }}
            <span class="text-muted small">{{ mapUnitOrOriginal(data.item.unitsDisplay) || '' }}</span>
          </div>
          <div v-if="data.item.predictionValueUnitsModel">
            {{ formatValue(data.item.predictionValueUnitsModel, data.item.unitsModel) }}
            <span class="text-muted small">{{ mapUnitOrOriginal(data.item.unitsModel) || '' }}</span>
          </div>
        </template> -->

        <template #cell(experimental)="data">
          <div v-if="data.item?.experimentalValueUnitsDisplay">
            {{ formatValue(data.item.experimentalValueUnitsDisplay, data.item.unitsDisplay) }}
            <span class="text-muted small">{{ mapUnitOrOriginal(data.item.unitsDisplay) || '' }}</span>
          </div>

          <div v-if="data.item?.experimentalValueUnitsModel && shouldShowUnitsModel(data.item)">
            {{ formatValue(data.item.experimentalValueUnitsModel, data.item.unitsModel) }}
            <span class="text-muted small">{{ mapUnitOrOriginal(data.item.unitsModel) || '' }}</span>
          </div>
        </template>

        <template #cell(ad_result)="data">
          <div>
            <span :class="getAdResultClass(data.item)">{{ getAdResultConclusion(data.item) }}</span>
          </div>
        </template>

        <template #cell(ad_distance)="data">
          <div>
            {{ getAdReasoning(data.item) }}
          </div>
        </template>
      </b-table-lite>
    </v-card-text>
  </v-card>

  <v-card
    v-else
    class="p-2"
  >
    {{ params?.column?.colDef?.headerTooltip }}
  </v-card>
</template>

<style scoped>
.text-underlined {
  text-decoration: underline;
}
</style>
